import Auth from '@/modules/auth/routes'
import Calendar from '@/modules/calendar/routes'
import Company from '@/modules/company/routes'
import Dashboard from '@/modules/dashboard/routes'
import Deals from '@/modules/deals/routes'
import Emails from '@/modules/emails/routes'
import MassiveEmails from '@/modules/emails/massive/routes'
import Errors from '@/modules/errors/routes'
import FollowUps from '@/modules/follow-ups/routes'
import Incoming from '@/modules/incoming/routes'
import Integrations from '@/modules/integrations/routes'
import Leads from '@/modules/leads/routes'
import MyQuotation from '@/modules/my-quotation/routes'
import Parameters from '@/modules/parameters/routes'
import Profile from '@/modules/profile/routes'
import Pipeline from '@/modules/pipeline/routes'
import Quotations from '@/modules/quotations/routes'
import Root from './root'
import Start from 'modules/start/routes'
import Support from '@/modules/support/routes'
import Templates from '@/modules/templates/routes'

import DealsReport from '@/modules/reports/deals/routes'
import LossReasonsReport from '@/modules/reports/loss-reasons/routes'
import PipelinesReport from '@/modules/reports/pipelines/routes'
import SalesReport from '@/modules/reports/sales/routes'
import SourcesReport from '@/modules/reports/sources/routes'
import TasksReport from '@/modules/reports/tasks/routes'
import FollowUpsReport from '@/modules/reports/follow-ups/routes'

export default [
    ...Auth,
    ...Calendar,
    ...Company,
    ...Dashboard,
    ...Deals,
    ...Emails,
    ...MassiveEmails,
    ...Errors,
    ...FollowUps,
    ...Incoming,
    ...Integrations,
    ...Leads,
    ...MyQuotation,
    ...Parameters,
    ...Profile,
    ...Pipeline,
    ...Quotations,
    ...Root,
    ...Start,
    ...Support,
    ...Templates,

    ...DealsReport,
    ...LossReasonsReport,
    ...PipelinesReport,
    ...SalesReport,
    ...SourcesReport,
    ...TasksReport,
    ...FollowUpsReport
]



// WEBPACK FOOTER //
// ./src/router/routes.js